import React from 'react';
import { FaCheckCircle, FaExclamationTriangle, FaQuestionCircle, FaSyncAlt } from 'react-icons/fa';
import '../../css/financeiro-parcela-pagar.css';

// Conferência automática da NF (treinamento 07/10, item 21). A API devolve em cada NF
// `validacao = { status: ok|divergente|nao_verificado, mensagem, itens: [{codigo,status,mensagem}] }`
// (só os itens divergentes/não verificados). NF anterior ao recurso vem sem `validacao` → nada aparece.
// D-0122: apólice, recibo, fatura e invoice também são conferidos; a API manda `documento` e o
// `selo` pronto ("Apólice conferida", "Recibo não analisado") — sem `selo`, vale o texto de NF.
// Só AVISA: nenhum botão é desabilitado por causa disto.

/** 21415772000164 → 21.415.772/0001-64 (devolve como veio se não tiver 14 dígitos). */
export const formatarCnpj = (v) => {
    const d = String(v || '').replace(/\D/g, '');
    return d.length === 14 ? d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5') : String(v || '');
};

const ORDEM = { divergente: 3, nao_verificado: 2, ok: 1 };

const ROTULO = {
    ok: { classe: 'is-ok', texto: 'NF conferida', Icone: FaCheckCircle },
    divergente: { classe: 'is-warn', texto: 'NF divergente', Icone: FaExclamationTriangle },
    nao_verificado: { classe: 'is-muted', texto: 'NF não analisada', Icone: FaQuestionCircle },
};

/** A pior situação entre várias NFs (divergente > não analisada > ok); null se nenhuma tem conferência. */
export const piorValidacao = (nfs) => {
    let pior = null;
    (nfs || []).forEach((nf) => {
        const v = nf && nf.validacao;
        if (v && ORDEM[v.status] && (!pior || ORDEM[v.status] > ORDEM[pior.status])) pior = v;
    });
    return pior;
};

export function NfValidacaoPill({ validacao, title }) {
    if (!validacao || !ROTULO[validacao.status]) return null;
    const r = ROTULO[validacao.status];
    return (
        <span className={'fin-pp__pill ' + r.classe} title={title || validacao.mensagem} style={{ whiteSpace: 'nowrap' }}>
            {validacao.selo || r.texto}
        </span>
    );
}

export function NfValidacaoDetalhe({ validacao, onRevalidar, revalidando, compacto, rotuloRevalidar = 'Conferir de novo' }) {
    if (!validacao || !ROTULO[validacao.status]) return null;
    const classeBanner = validacao.status === 'divergente' ? 'is-warn' : validacao.status === 'ok' ? 'is-ok' : 'is-info';
    const Icone = ROTULO[validacao.status].Icone;
    const itens = validacao.itens || [];
    return (
        <div className={'fin-pp__banner ' + classeBanner} style={{ marginBottom: 0, alignItems: 'flex-start', fontSize: compacto ? 12.5 : 13 }}>
            <span className="fin-pp__banner-ic"><Icone size={14} /></span>
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600 }}>{validacao.mensagem}</div>
                {itens.length > 0 && (
                    <ul style={{ margin: '6px 0 0', padding: 0, listStyle: 'none' }}>
                        {itens.map((it, i) => {
                            const Ic = it.status === 'divergente' ? FaExclamationTriangle : FaQuestionCircle;
                            return (
                                <li key={it.codigo + '-' + i} style={{ margin: '4px 0', display: 'flex', gap: 6, alignItems: 'flex-start' }}>
                                    <Ic size={11} style={{ flex: 'none', marginTop: 3, opacity: 0.85 }} />
                                    <span>{it.mensagem}</span>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
            {onRevalidar && (
                <button type="button" className="fin-pp__btn fin-pp__btn--sm" style={{ flex: 'none' }}
                    disabled={revalidando} onClick={onRevalidar} title="Lê a nota de novo e refaz a conferência">
                    <FaSyncAlt size={11} /> {revalidando ? 'Conferindo…' : rotuloRevalidar}
                </button>
            )}
        </div>
    );
}
